import React, { Component } from 'react'
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import './BenefitsTable.css'
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { PRIMARY_THEME_COLOR_SHADE_1 } from '../../../../lib/constants';

export default class FixedIndemnityTable extends Component {

  constructor(props) {
    super(props);

    this.state = {
      benefits: []
    };
  }

  componentWillMount() {
    this.setState({ benefits: this.props.fixedBenefits })
  }

  componentDidUpdate() {
    const propsBenefitsLength = this.props.fixedBenefits.length
    const stateBenefitsLength = this.state.benefits.length
    if (propsBenefitsLength !== stateBenefitsLength) {
      this.setState({ benefits: this.props.fixedBenefits })
    }
  }

  toggleCollapse = (index) => {
    const currentBenefits = this.state.benefits
    currentBenefits[index]['rowCollapsed'] = !currentBenefits[index]['rowCollapsed']
    this.setState({ benefits: currentBenefits })
  }

  setBenefitToEdit = (benefit) => {
    const payload = benefit
    payload['benefitType'] = 'fixed';
    this.props.setBenefitToEdit(payload)
  }



  render() {
    if (this.props.fixedBenefits && this.props.fixedBenefits.length > 0) {
      return (
        <>
          <div style={{ marginTop: "2%", }}>
            <h3 style={{ textAlign: 'left' }}>Fixed Indemity benefits</h3>

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead style={{ color: 'red' }}>
                  <TableRow >
                    <TableCell className="table-cell-header"></TableCell>
                    <TableCell className="table-cell-header">name</TableCell>
                    <TableCell className="table-cell-header">amount_benefit</TableCell>
                    <TableCell className="table-cell-header">principal_max_age_limit</TableCell>
                    <TableCell className="table-cell-header" align="right">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.benefits.map((benefit, index) => {
                    return (
                      <>
                        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                          <TableCell>
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={() => this.toggleCollapse(index)}
                            >
                              {benefit.rowCollapsed ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            </IconButton>
                          </TableCell>
                          <TableCell component="th" scope="row"> {benefit.name}</TableCell>
                          <TableCell align="left"> {benefit.amount_benefit}</TableCell>
                          <TableCell align="left"> {benefit.principal_max_age_limit}</TableCell>


                          <TableCell align="right">
                            <Stack direction="row" spacing={1} justifyContent="flex-end" >
                              <IconButton onClick={this.setBenefitToEdit.bind(this, benefit)} >
                                <EditIcon
                                  style={{ color: PRIMARY_THEME_COLOR_SHADE_1, fontWeight: 'bolder', display: this.props.displayEditButton ? 'inline-block' : 'none' }}
                                />
                              </IconButton>
                              <IconButton onClick={() => { this.props.hardDeleteBenefit({ benefit, benefitType: 'fixed_indemnity' }) }} >
                                <DeleteForeverIcon
                                  style={{ color: 'red', fontWeight: 'bolder', marginRight: "2%", display: this.props.displayDeleteButton ? 'inline-block' : 'none' }}
                                />
                              </IconButton>
                            </Stack>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                            <Collapse in={benefit.rowCollapsed} timeout="auto" unmountOnExit>
                              <Box sx={{ margin: 1 }}>
                                <Table size="small" aria-label="purchases">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell className="table-cell-header-collapsed">spouse_max_age_limit</TableCell>
                                      <TableCell className="table-cell-header-collapsed">spouse_min_age_limit</TableCell>
                                      <TableCell className="table-cell-header-collapsed">child_max_age_limit</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRow>
                                      <TableCell align="left"> {benefit.spouse_max_age_limit}</TableCell>
                                      <TableCell align="left"> {benefit.spouse_min_age_limit}</TableCell>
                                      <TableCell align="left"> {benefit.child_max_age_limit}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </>
      );
    }
    else {
      return ""
    }
  }
}
